/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let openapi = window._env_.VUE_APP_OPEN_API_HOST
let imgr = window._env_.VUE_APP_IMG_FLOW_HOST
let sjfBase = window._env_.VUE_APP_SJF_API_HOST


export const getOrderDetail = ({id}) => {
  return axios.get(`${base}/order_${id}`)
}
export const updateOrderReviewAnswer = (params) => {
  return axios.post(`${base}/modify_answer_order_${params.id}`, params)
}
export const reviewOrderPass = (params) => {
  return axios.post(`${base}/pass_audit_order_${params.id}`, params)
}
export const reviewOrderNotPass = (params) => {
  return axios.post(`${base}/fail_audit_order_${params.id}`, params)
}
// 获取推荐待审核工单数量
export const getUnauditedOrdersCount = (params) => {
  return axios.post(`${base}/order/get_unaudited_orders_count`, params)
}
// 获取推荐待审核宴席工单数量
export const getUnauditedBanquetOrdersCount = (params) => {
  return axios.post(`${base}/order/get_unaudited_banquet_orders_count`, params)
}
// 推荐待审核工单
export const getRecommendOrder = (params) => {
  return axios.post(`${base}/order/recommend_order`, params)
}

export const getRecommendBanquetOrderApi = (params) => {
  return axios.post(`${base}/order/recommend_banquet_order`, params)
}

export const uploadOrderReviewFile = (params) => {
  return axios.post(`${base}/order_uploadfile`, params)
}
export const uploadOrderReviewDirectFile = (params) => {
  return axios.post(`${base}/order_direct_uploadfile`, params)
}
export const lockOrder = (params) => {
  return axios.post(`${base}/lock_order_${params.id}`, params)
}
export const reviewClbOrderPass = (params) => {
  return axios.post(`${base}/clb/pass_audit_order_${params.id}`, params)
}
export const acquireOrder = (params) => {
  return axios.post(`${base}/order/audit/acquire_${params.id}`, params)
}
export const releaseOrder = (params) => {
  return axios.post(`${base}/order/audit/release_${params.id}`, params)
}
export const saveOrderReviewCache = (params) => {
  return axios.post(`${base}/order/set_cache_${params.id}`, params)
}
export const readOrderReviewCache = (params) => {
  return axios.get(`${base}/order/get_cache_${params.id}`, params)
}
// 获得图像识别结果
export const findRecognitionResults = (params) => {
  return axios.post(`${imgr}/app/ask_detection_result`, params)
}

// 获得与标题匹配的识别产品
export const matchRecognitionQuestionProduct = (params) => {
  return axios.post(`${imgr}/app/ask_existance_of_product`, params)
}
/**
 * 反馈识别异常
 */
export const feedbackImageRecognitionException = (params) => {
  return axios.post(`${imgr}/update_image/is_exception/${params.id}`, params)
}
/**
 * 获得题目的拼接照片
 */
export const getOrderReviewQuestionJoinImg = (params) => {
  return axios.get(`${imgr}/app/ask_splice_question_image/${params.id}`)
}
// 查询工单审核历史
export const getOrderReviewHistoryTable = (params) => {
  return axios.post(`${base}/order/history/query`, params)
}
// 获得工单审核历史详情
export const getOrderReviewHistoryDetail = (params) => {
  return axios.get(`${base}/order/history/get_${params.id}`, {params})
}
// 获得工单审核历史的问题是否修改状态
export const getOrderReviewHistoryQuestionStatus = (params) => {
  return axios.get(`${base}/order/history/step_status_${params.id}`, {params})
}
// 添加工单审核录音证据的标记点
export const saveOrderReviewAudioMarkers = (params) => {
  return axios.post(`${base}/order/upload_record_marker`, params)
}
// 检测工单状态
export const checkOrderStatus = (params) => {
  return axios.get(`${base}/order/check_status_${params.id}`, {params})
}

// 获取直播工单审核
export const getOrderLiveDetail = (params) => {
  return axios.get(`${openapi}/jnc/order/get_${params.id}`, {params})
}

// sjf 订单详情接口
export const getSJFOrderDetail = (params) => {
  return axios.get(`${sjfBase}/admin/admin2/task_banquet_data_${params.id}`, {params})
}

export const getSJFPlatformSetting = (params) => {
  return axios.get(`${sjfBase}/admin/admin2/settings/all`, {params})
}

// 工单复核 API
export const reviewOrderQuality = (params) => {
  return axios.post(`${base}/order/review_quality`, params)
}

// 工单 ASR 风险检查结果
export const getAudioAsrCheckOrderResult = ({id}) => {
  return axios.get(`${base}/audio_asr_check_order_result_${id}`)
}

// 任务审核参照数据
export const getTaskAuditReference = (params) => {
  return axios.get(`${base}/task/audit_reference`, {params})
}



// WEBPACK FOOTER //
// ./src/views/order-review/order-review.api.js